<div id="container">
    <img src="../../../assets/prev.png" alt="" width="8px" height="15px" id="button" (click)="PrevMonth()">
    <div id="title">{{months[now.getMonth()]}} {{now.getFullYear()}}</div>
    <img src="../../../assets/next.png" alt="" width="8px" height="15px" id="button" (click)="NextMonth()">
</div>
